(function () {
  'use strict';

  // Synchronize the focusable state of a single slide
  function syncSlideFocusability(slideEl) {
    var isHidden = slideEl.getAttribute('aria-hidden') === 'true';
    var focusableEls = slideEl.querySelectorAll('a, button, input, select, textarea, [tabindex]');

    focusableEls.forEach(function (el) {
      if (isHidden) {
        // Record the original tabindex to facilitate restoration
        if (!el.hasAttribute('data-original-tabindex') && el.hasAttribute('tabindex')) {
          el.setAttribute('data-original-tabindex', el.getAttribute('tabindex'));
        }
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');
      } else {
        if (el.hasAttribute('data-original-tabindex')) {
          el.setAttribute('tabindex', el.getAttribute('data-original-tabindex'));
          el.removeAttribute('data-original-tabindex');
        } else {
          el.removeAttribute('tabindex');
        }
        el.removeAttribute('aria-hidden');
      }
    });
  }

  // Listen for the changes in the aria-hidden attribute of all slides within a certain carousel container
  function observeSlider(sliderEl) {
    var slides = sliderEl.querySelectorAll('.collection-slider-item');

    // Run it once during initialization to avoid any issues on the first screen.
    slides.forEach(syncSlideFocusability);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          syncSlideFocusability(mutation.target);
        }
      });
    });

    slides.forEach(function (slide) {
      observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
  }

  function initAll() {
    document.querySelectorAll('.collection-slider').forEach(observeSlider);
  }

  // Flickity might be initialized asynchronously. Delay the binding slightly to ensure that the DOM/aria-hidden elements have been generated.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initAll, 300);
    });
  } else {
    setTimeout(initAll, 300);
  }

  // If there are dynamically inserted new carousels on the page (such as sections loaded asynchronously), also listen to the body
  var bodyObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && node.classList && node.classList.contains('collection-slider')) {
          observeSlider(node);
        }
      });
    });
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });
})();